import { TTextAlign } from 'types/media'

export const MIN_FONT_SIZE = 24
export const MAX_FONT_SIZE = 400

export const MIN_STROKE_THICKNESS = 0
export const MAX_STROKE_THICKNESS = 28
export const DEFAULT_LINE_HEIGHT = 1.2
export const DEFAULT_TEXT_ALIGN: TTextAlign = 'center'
